var priceIncrement = {

    methods: {

        /**
         * Return the price plus incremenr
         *  @param price String
         */

        getPriceWithIncrement: function( price ) {

            let p = parseInt( price )
            let increment = parseInt ( this.getGroupIncrement )

            let priceIncrement = p + increment

            return priceIncrement

        }

    }

}

export default priceIncrement